import React from 'react';
import {
  FormControl as MuiFormControl,
  Select as MuiSelect,
  InputLabel as MuiInputLabel,
  MenuItem as MuiMenuItem,
  FormHelperText,
} from '@mui/material';

function ComboBasic({
  items = [], // object array
  wrapSx, // object
  color, // 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning'
  size, // 'medium' | 'small'
  fullWidth = false, // bool
  required = false, // bool
  disabled = false, // bool
  autoWidth = false, // bool
  classes, // node
  defaultOpen = false, // bool
  displayEmpty = false, // bool
  IconComponent, // elementType
  id = '', // string
  input, // element
  inputProps, // object
  name, // node
  nameId = '', // string
  MenuProps, // object
  multiple, // object
  native = false, // bool
  open, // bool
  SelectDisplayProps, // object
  sx, // object
  value = '', // any
  variant = 'outlined', // 'filled' | 'outlined' | 'standard'
  helperText = '', //string
  error = false, // bool
  onOpen = (e) => {},
  onClose = (e) => {},
  onChange = (e) => {},
  onClick = (e) => {},
}) {
  const ChangeSelect = (e) => {
    onChange(e.target.value);
  };

  const OpenSelect = (e) => {
    onOpen(e);
  };

  const CloseSelect = (e) => {
    onClose(e);
  };
  
  const ClickSelect = (e) => {
    onClick(e);
  };

  // displayEmpty: value가 ''여도 "전체"가 그려짐. MUI는 ''를 비어있다고 보아 기본은 라벨이 안 올라가 겹침 발생 → displayEmpty일 때는 라벨 항상 shrink
  const inputLabelShrink = displayEmpty ? true : undefined;

  return (
    <MuiFormControl
      sx={wrapSx}
      color={color}
      size={size}
      fullWidth={fullWidth}
      required={required}
      disabled={disabled}
      error={error}
    >
      <MuiInputLabel shrink={inputLabelShrink} id={nameId || undefined}>
        {name}
      </MuiInputLabel>
      <MuiSelect
        autoWidth={autoWidth}
        classes={classes}
        defaultOpen={defaultOpen}
        displayEmpty={displayEmpty}
        IconComponent={IconComponent}
        id={id}
        input={input}
        inputProps={inputProps}
        label={name}
        labelId={nameId}
        MenuProps={MenuProps}
        multiple={multiple}
        native={native}
        open={open}
        SelectDisplayProps={SelectDisplayProps}
        sx={sx}
        value={value}
        variant={variant}
        onOpen={OpenSelect}
        onClose={CloseSelect}
        onChange={ChangeSelect}
        onClick={ClickSelect}
      >
        {items.map((item, index) => {
          return (
            <MuiMenuItem key={index} value={item.value}>
              {item.name}
            </MuiMenuItem>
          );
        })}
      </MuiSelect>
      <FormHelperText>{helperText}</FormHelperText>
    </MuiFormControl>
  );
}

export default React.memo(ComboBasic);
